// Lightweight Google Analytics 4 wrapper with Consent Mode v2 support
// Note: CONSENT_KEY only stores a non-sensitive flag ("granted" | "denied")
// for GDPR Consent Mode v2. No PII, tokens or auth data ever stored here.
const GA_ID = "G-0XSCQ3DMDW";
const CONSENT_KEY = "yono_consent";

function safeGtag(...args) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function gaPageView(path) {
  safeGtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
    send_to: GA_ID,
  });
}

export function gaEvent(name, params = {}) {
  safeGtag("event", name, params);
}

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (err) {
    return null;
  }
}

export function setConsentGranted() {
  try {
    localStorage.setItem(CONSENT_KEY, "granted");
  } catch (err) {
    // localStorage may be blocked (private mode, quota) — ignore silently.
  }
  safeGtag("consent", "update", {
    analytics_storage: "granted",
    functionality_storage: "granted",
    security_storage: "granted",
  });
}

export function setConsentDenied() {
  try {
    localStorage.setItem(CONSENT_KEY, "denied");
  } catch (err) {
    // localStorage may be blocked — consent denied by default remains effective.
  }
  safeGtag("consent", "update", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
}
